<app-exam-header [pageTitle]="'FAQ'"></app-exam-header>
FAQ
<app-exam-footer></app-exam-footer>